import { Navigate } from "react-router-dom";
import { getRole, isAuthenticated } from "./auth";

/** Inside `ProtectedRoute`. Sends non–super-admins away from `/platform`. */
export default function SuperAdminRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: { pathname: "/platform" } }} replace />;
  }
  if (getRole() !== "superadmin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
